import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-panel',
  template: '<ng-content />',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent {}
